import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { I18nHelperService, TranslateService } from '@xref/ngx';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'xlog-reg-tc',
    templateUrl: './terms-conditions.component.pug',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: false
})
export class RegTermsConditionsComponent implements OnInit {
    @Output() acceptClicked = new EventEmitter();
    @Output() cancelClicked = new EventEmitter();

    tcForm = this.fb.group({
        agree: [false, Validators.requiredTrue],
        understand: [false, Validators.requiredTrue]
    });

    termsContent = '';

    constructor(
        private fb: UntypedFormBuilder,
        private translate: TranslateService,
        public sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.translate.setDefaultLang('en-au');
        this.translate.get('termsAndConditions.terms').subscribe((res: string) => {
            this.termsContent = res;
        });
    }

    accept() {
        const valid = !!this.tcForm.valid;
        if (valid) this.acceptClicked.emit(valid);
    }

    cancel() {
        this.cancelClicked.emit();
    }
}
